import React from 'react';
import { Mail, Phone } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { t } from '../translations';

const Footer = () => {
  const { language } = useLanguage();
  
  return (
    <footer className="bg-slate-950 text-slate-300 py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_gas-solutions-2/artifacts/8j44ql1b_Screenshot%202025-12-23%20114917.png" 
              alt="NOBLE Gases & Solutions" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-sm leading-relaxed">
              {t(language, 'footer.description')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t(language, 'footer.quickLinks')}</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#about" className="hover:text-emerald-400 transition-colors">{t(language, 'nav.about')}</a>
              </li>
              <li>
                <a href="#services" className="hover:text-emerald-400 transition-colors">{t(language, 'nav.services')}</a>
              </li>
              <li>
                <a href="#products" className="hover:text-emerald-400 transition-colors">{t(language, 'nav.products')}</a>
              </li>
              <li>
                <a href="#contact" className="hover:text-emerald-400 transition-colors">{t(language, 'nav.contact')}</a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t(language, 'footer.contactUs')}</h3>
            <div className="space-y-3 text-sm">
              <div className="flex items-start gap-2">
                <Mail className="h-4 w-4 text-emerald-400 flex-shrink-0 mt-0.5" />
                <div>
                  <a href="mailto:office@noble-gs.com" className="hover:text-emerald-400 transition-colors block">
                    office@noble-gs.com
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <Phone className="h-4 w-4 text-emerald-400 flex-shrink-0 mt-0.5" />
                <div>
                  <a href="tel:+381652426710" className="hover:text-emerald-400 transition-colors block">
                    +381 65 24 26 710 (WhatsApp, Viber)
                  </a>
                  <a href="tel:+381611340590" className="hover:text-emerald-400 transition-colors block">
                    +381 61 13 40 590 (WhatsApp, Viber)
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} {t(language, 'footer.rights')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;